import { createTheme } from '@material-ui/core';
import typography from './fonts';
import colorPalette from './color-palette';
import muiOverrides from './overrides';

import universltstdFont from '../fonts/ask-italian/UniversLTStd.ttf';
import universltstdBoldFont from '../fonts/ask-italian/UniversLTStd-Bold.ttf';
import universltstdCnFont from '../fonts/ask-italian/UniversLTStd-Cn.ttf';
import universltstdCnBoldFont from '../fonts/ask-italian/UniversLTStd-BoldCn.ttf';

const universltstd = {
  fontFamily: 'UniversLTStd',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 300,
  src: `
    url(${universltstdFont})
  `,
};

const universltstdBold = {
  fontFamily: 'UniversLTStd',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 'bold' as const,
  src: `
    url(${universltstdBoldFont})
  `,
};

const universltstdCn = {
  fontFamily: 'UniversLTStd-Cn',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 300,
  src: `
      url(${universltstdCnFont})
    `,
};

const universltstdBoldCn = {
  fontFamily: 'UniversLTStd-BoldCn',
  fontStyle: 'normal',
  fontDisplay: 'swap' as const,
  fontWeight: 'bold' as const,
  src: `
      url(${universltstdCnBoldFont})
    `,
};

const theme = createTheme({
  name: 'ask',
  spacing: 4,
  palette: {
    ...colorPalette,
  },
  typography: {
    h1: {
      fontFamily: typography.primaryBoldCondensed,
      fontSize: '2rem',
      fontWeight: 'bold' as const,
    },
    h2: {
      fontFamily: typography.primaryBoldCondensed,
      fontSize: '1.5rem',
      fontWeight: 'bold' as const,
    },
    h3: {
      fontFamily: typography.primaryBoldCondensed,
      fontSize: '1.25rem',
      fontWeight: 'bold' as const,
    },
    h4: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 'bold' as const,
    },
    h5: {
      fontFamily: typography.primary,
      fontSize: '1rem',
      fontWeight: 'bold' as const,
    },
    subtitle1: {
      fontFamily: typography.primary,
      fontSize: '0.85rem',
      fontWeight: 'bold' as const,
    },
    subtitle2: {
      fontFamily: typography.primary,
      fontSize: '1rem',
      fontWeight: 'normal' as const,
    },
    body1: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: 1.2,
    },
    body2: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 'bold' as const,
      lineHeight: 1.5,
    },
    button: {
      fontFamily: typography.primary,
      fontSize: '0.875rem',
      fontWeight: 'bold' as const,
      textTransform: 'none',
    },
    overline: {
      fontFamily: typography.primaryBoldCondensed,
      fontSize: '0.625rem',
      lineHeight: 1.3,
      fontWeight: 300,
      letterSpacing: '0.025rem',
      textTransform: 'none',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [universltstd, universltstdBold, universltstdCn, universltstdBoldCn],
      },
    },
    ...muiOverrides,
  },
  splashImage: '/images/ask-splash.svg',
});

export default theme;
